var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns"},[_vm._m(0),(_vm.report_details && _vm.raw_images && _vm.active_thumbnail)?_c('div',{staticClass:"column is-4"},[_c('thumbnail-details',{attrs:{"image":_vm.raw_images[_vm.active_thumbnail.filename],"details":_vm.report_details.datas[_vm.active_thumbnail.key]}})],1):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column is-8"},[_c('div',{attrs:{"id":"map"}})])
}]

export { render, staticRenderFns }